<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import Image from "@components/Image/Image.svelte";

    export let selected: boolean | null;
    export let title: string;
    export let imageUrl: string | undefined;
    export let url: string;
    export let variantTitle = "";
    export let tagId: number;
    export let price: number | null = null;
    const dispatch = createEventDispatcher();
    const handleTagEnter = (id: number) => {
        dispatch("tag_select", id);
    };
    const handleTagLeave = () => {
        dispatch("tag_unselect");
    };
</script>

<div
    on:mouseenter={() => handleTagEnter(tagId)}
    on:mouseleave={handleTagLeave}
    class="gw-post-modal-tag-card"
    class:gw-post-modal-tag-card--selected={selected}
>
    <div class="gw-post-modal-tag-card__image-wrapper">
        {#if imageUrl}
            <Image
                alt={title || variantTitle}
                src={imageUrl}
                wrapperClassName="gw-post-modal-tag-card__image"
                objectFit="contain"
                backdropClassName="gw-post-modal-tag-card__backdrop"
            />
        {/if}
    </div>
    <div
        class="gw-post-modal-tag-card__content"
        class:justify-content-reset={price === 0}
    >
        <a
            aria-label={`Opens the product ${title} in a new tab`}
            href={url}
            class="gw-link-reset-default-styles gw-post-modal-tag-card__link"
            rel="noopener noreferrer"
            target="_blank"
        >
            <p class="gw-post-modal-tag-card__title-text gw-default-reset">
                {title}
            </p>
        </a>
        <slot />
        <slot name="button" />
    </div>
</div>

<style>
    .gw-post-modal-tag-card {
        display: grid;
        align-items: flex-start;
        padding: 16px;
        column-gap: 16px;
        border-radius: 11px;
        background: var(--gw-modal-tag-card);
        box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.03);
        cursor: pointer;
        grid-template-columns: 1fr 2fr;
    }

    .gw-post-modal-tag-card--selected {
        box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.07);
        background: var(--gw-lightgrey-bg);
    }

    .gw-post-modal-tag-card__image-wrapper {
        width: 122px;
        height: 137px;
        border-radius: 7.5px;
    }

    .gw-post-modal-tag-card__title-text {
        color: var(--gw-post-modal-text-color);
        font-size: 1em;
        line-height: 1.3em;
    }
    .gw-post-modal-tag-card__content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .justify-content-reset {
        justify-content: revert;
    }
    @media all and (max-width: 325px) {
        .gw-post-modal-tag-card {
            grid-template-columns: 1fr;
            grid-gap: 10px;
        }
    }
</style>
